import type { ComponentClassNames } from '../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

type SemanticHeadingClassNames = ComponentClassNames<'semanticHeading'>;

type GetClassNames = () => SemanticHeadingClassNames;
export const getClassNames: GetClassNames = memoizeFunction(
  (): SemanticHeadingClassNames =>
    mergeStyleSets({
      semanticHeading: [
        {
          display: 'inline',
          fontSize: 'inherit',
          lineHeight: 'inherit',
          fontWeight: 'inherit',
          marginTop: 0,
          marginBottom: 0,
        },
      ],
    })
);
